
function IssueStageCtrl(TranslationService, HelpdeskService, ToastService, CommentsService, $uibModal, $rootScope, $timeout) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.loading = false;

    ctrl.isCurrent = function (stage) {
        if (stage.StageID == 'Current') {
            return true;
        }
        return false;
    }

    ctrl.isChecked = function (stage) {
        if (stage.StageID == 'Done') {
            return true;
        }
        return false;
    }

    ctrl.isCurrentOrChecked = function (stage) {
        return stage.Visible;
    }

    ctrl.field = function (fieldName) {
        var field = ctrl.stage.Fields.find(function (field) {
            return field.Name == fieldName;
        });
        return field;
        //if (field) {
        //    return true;
        //}
    }

    ctrl.stageHasField = function (stageID, fieldName) {
        var stage = ctrl.stage;
        if (!stage.Fields) {
            return false;
        }
        var field = stage.Fields.find(function (field) {
            return field.Name == fieldName;
        });
        if (field) {
            return true;
        }
        return false;
    }

    //ctrl.isApprovalRequired = function (approval) {
    //    //console.log('approval', approval, ctrl.issue.CreditNoteClaim);        
    //    return HelpdeskService.isApprovalRequired(ctrl.issue.CreditNoteClaim, approval);        
    //};

    ctrl.loadComments = function (issue) {
        //console.log('loadComments');
        CommentsService.resetCache();
        CommentsService.list(issue.IssueID, 'ISSUE').then(function (data) {
            //console.log('loaded comments');
            issue.Comments = data.data;            
        });
    };

    ctrl.toPdf = function () {
        ctrl.loading = true;
        $rootScope.$broadcast('downloadPdfIssue');
        $rootScope.$on('downloadPdfIssueComplete', function () {
            ctrl.loading = false;
        });
    }
    
    ctrl.getFieldType = function (fieldName)
    {
        if (fieldName == 'StageResponse') {
            return 'textarea';
        }
        else if (fieldName == 'CreditNoteClaim') {
            return 'finance';
        }
        else if (fieldName == 'CreditNoteFinal') {
            return 'finance';
        }        
        else {
            return 'text';
        }
    };

    ctrl.showField = function (fieldName) {
        return HelpdeskService.showCreditNoteField(ctrl.issue, fieldName);
    };

    //ctrl.showField = function (fieldName) {
    //    if (ctrl.issue.HasCreditNote) {
    //        return true;
    //    }
    //    var costFields = ['CreditNoteClaim', 'CreditNoteFinal', 'CreditNoteOrderID'];
    //    var index = costFields.findIndex(function (name) {
    //        if (name == fieldName) {
    //            return true;
    //        }
    //    });
    //    var isCost = index >= 0;
    //    //console.log(fieldName + ' ' + index + ' ' + isCost);
    //    return !isCost;        
    //};


    ctrl.updateApproval = function (user) {
        //console.log('toggle approval ', user);        
        user.StageID = ctrl.stage.StageID;
        HelpdeskService.updateApproval(ctrl.issue.IssueID, user).then(function (response) {
            //console.log('UPDATED', response.data);
            var approv = response.data;

            user.Comment = approv.Comment
            user.IsApproved = approv.IsApproved;
            user.ApprovalDate = approv.ApprovalDate;
            
            ctrl.issue.AssignedApprovalUserID = approv.AssignedApprovalUserID;
           
            if (approv.Approvals) {
                ctrl.issue.ApprovalUsers = approv.Approvals;
            }

            ctrl.loadComments(ctrl.issue);
            HelpdeskService.resetCache();
            ToastService.createToast('Saved', '', 4000, 'success');
        },
            function (error) {
                var err = ToastService.getErrorMsg(error);
                ToastService.createToast('Error', err, 4000, 'error');
            }
        );
    }

    ctrl.showApproval = function (user) {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'SPA/helpdesk/approvalModal.html',
            controller: 'ApprovalModalController',
            size: 'md',
            resolve: {
                info: function () {
                    return {                        
                        Issue: ctrl.issue,
                        User: user,
                    }
                },
                //isDanger: false,
            }
        });

        modalInstance.result.then(
            function (ap) {          
                console.log('SHOW APPROVAL ', ap);
                if (ap) {                    
                    var userData = Object.assign({}, user);
                    userData.Comment = ap.Comment;
                    userData.IsApproved = ap.IsApproved;
                    ctrl.updateApproval(userData);
                }
            }, function () {
        });
    };
}

IssueStageCtrl.$inject = ['TranslationService', 'HelpdeskService', 'ToastService', 'CommentsService', '$uibModal', '$rootScope', '$timeout'];

seedWebApp.component('issueStage', {
    controller: IssueStageCtrl,
    controllerAs: 'ctrl',
    bindings: {
        issue: '<',
        stage: '<',        
    },
    templateUrl: '/SPA/helpdesk/issueStage.html' + seedWebApp.buildVersion
});
